import { render, staticRenderFns } from "./CountersTableGBS.vue?vue&type=template&id=f483e8ca&scoped=true&"
import script from "./CountersTableGBS.vue?vue&type=script&lang=js&"
export * from "./CountersTableGBS.vue?vue&type=script&lang=js&"
import style0 from "./CountersTableGBS.vue?vue&type=style&index=0&id=f483e8ca&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f483e8ca",
  null
  
)

export default component.exports